webpackJsonp([19],{

/***/ "0Flw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/modules/auth.js
/* harmony default export */ var auth = ({
    namespaced: true,
    state: {},
    mutation: {}
});
// CONCATENATED MODULE: ./src/store/modules/index.js


/* harmony default export */ var modules = ({
  auth: auth
});
// CONCATENATED MODULE: ./src/store/index.js


var _mutations;






vue_esm["default"].use(vuex_esm["a" /* default */]);

var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGOUT = 'LOGOUT';
var SET_ROLE = 'SET_ROLE';
var DYN_CON_DONE = 'DYN_CON_DONE';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
    state: {
        contents: {
            holidays: [],
            data: [],
            prestationOptions: [],
            configData: [],
            configFilterData: [],
            orderDbHash: null
        },
        isDynContentLoaded: false,
        isLoggedIn: false,
        isAdmin: false,
        userRole: null,
        appRootPath: null,
        UserLogin: null
    },
    getters: {
        getUserRole: function getUserRole(state) {
            return state.userRole;
        },
        isDynContLoaded: function isDynContLoaded(state) {
            return state.isDynContentLoaded;
        }
    },
    mutations: (_mutations = {}, defineProperty_default()(_mutations, LOGIN_SUCCESS, function (state, login) {
        state.isLoggedIn = true;
        state.UserLogin = login;
    }), defineProperty_default()(_mutations, SET_ROLE, function (state, userRight) {
        switch (userRight) {
            case 'admin':
                state.userRole = 'admin';
                state.appRootPath = '/admin/dashboard';
                state.isAdmin = true;
                break;
            case 'referent':
                state.userRole = 'referent';
                state.appRootPath = '/admin/dashboard';
                state.isAdmin = true;
                break;
            case 'clerc':
                state.userRole = 'clerc';
                state.appRootPath = '/office/welcome';
                state.isAdmin = false;
                break;
            case 'etude':
                state.userRole = 'etude';
                state.appRootPath = '/office/welcome';
                state.isAdmin = false;
                break;
            default:
                break;
        }
        return state.userRole;
    }), defineProperty_default()(_mutations, LOGOUT, function (state) {
        state.isLoggedIn = false;
        state.userRole = null;
        state.appRootPath = '/';
        state.isAdmin = false;
    }), defineProperty_default()(_mutations, DYN_CON_DONE, function (state) {
        state.isDynContentLoaded = true;
    }), _mutations),
    actions: {
        login: function login(_ref, creds) {
            var state = _ref.state,
                commit = _ref.commit;

            //console.log("actions: login");
            commit(LOGIN_SUCCESS, creds.login);
            commit(SET_ROLE, creds.user_right);
            // FIXME: transform this into a promise for more control
            // return new Promise(resolve => {
            //   resolve();
            // });
        },
        logout: function logout(_ref2) {
            var state = _ref2.state,
                commit = _ref2.commit;

            commit(LOGOUT);
        },
        dynContentLoaded: function dynContentLoaded(_ref3) {
            var state = _ref3.state,
                commit = _ref3.commit;

            commit(DYN_CON_DONE);
        }
    },
    modules: modules
}));
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./src/config/env.js
var env = __webpack_require__("uaSg");

// CONCATENATED MODULE: ./src/router/routes.js


var routes = [{
    path: '/',
    name: 'Top',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KHqs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '' + env["c" /* DOMAIN_TITLE */], auth: false }
}, {
    path: '/login',
    name: 'Login',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("P7ry")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Login', auth: false }
}, {
    path: '/office',
    name: 'office',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("g8C4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { adminAuth: false, auth: true },
    children: [{
        path: 'welcome',
        name: 'welcome',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("e/+J")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Accueil', adminAuth: false, auth: true }
    }, {
        path: 'order',
        name: 'newOrder',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tbqc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Nouvelle commande', adminAuth: false, auth: true }
    }, {
        path: 'orderList',
        name: 'orderList',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FO3K")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Liste commandes', adminAuth: false, auth: true }
    }, {
        path: 'faq',
        name: 'faq',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+tlw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | FAQ', adminAuth: false, auth: true }
    }, {
        path: 'changePasswords',
        name: 'changePasswords',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jn8W")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Changer mot de passes', adminAuth: false, auth: true }
    }]
}, {
    path: '/admin',
    name: 'admin',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/wdL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { adminAuth: true },
    children: [{
        path: 'dashboard',
        name: 'dashboard',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hRx6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Dashboard', adminAuth: true, auth: true }
    }, {
        path: 'calendar',
        name: 'calendar',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ij6J")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Calendrier', adminAuth: true, auth: true }
    }, {
        path: 'orders',
        name: 'orderListAdmin',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ss4J")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Commandes', adminAuth: true, auth: true }
    }, {
        path: 'users',
        name: 'users',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ABZ1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Utilisateurs', adminAuth: true, auth: true }
    }, {
        path: 'dyn-contents',
        name: 'dynContents',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("elGi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Contenus dynamiques', adminAuth: true, auth: true }
    }, {
        path: 'user-history',
        name: 'userHistory',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lc1r")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Historique des actions utilisateurs', adminAuth: true, auth: true }
    }, {
        path: 'statistic',
        name: 'statistic',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+2fH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Statistique', adminAuth: true, auth: true }
    }]
}, {
    path: '*',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("c5Mg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Erreur 404' }
}];
// CONCATENATED MODULE: ./src/router/middlewares.js



// export function guardRoute(to, from, next) {
//   // const isAppRoute = to.path('/office');
//   const isAdminRoute = to.matched.some(item => item.meta.adminAuth);
//   let isAdmin = $store.state.userRole === 'admin' || $store.state.userRole === 'referent';
//   if (isAdminRoute) {
//     if (isAdmin) return next();
//     return next(false);
//   }
//   if (!$store.state.isLoggedIn && to == '/office') {
//     console.log('test guardroute for office');
//     setTimeout(() => {
//       return window.location.href = SITE_URL;
//     }, 100);
//     // next('/');
//     // return window.location.href = SITE_URL;
//   }
//   next();
// }

// export function guardRoute(to, from, next) {
// console.log(to);
// console.log(from);
// console.log(next);
// }

/*
export function guardRoute(to, from, next) {
    console.log("guardRoute");
    
  const isAdminRoute = to.matched.some(item => item.meta.adminAuth);
  let isAdmin = $store.state.userRole === 'admin' || $store.state.userRole === 'referent';
  if (isAdminRoute) {
    if (isAdmin) return next();
    return next(false);
  }
  next();
};*/

function updatePageTitle(to, from, next) {
    var pageTitle = to.matched.find(function (item) {
        return item.meta.title;
    });
    pageTitle ? window.document.title = pageTitle.meta.title : window.document.title = env["c" /* DOMAIN_TITLE */];
    next();
}
// CONCATENATED MODULE: ./src/router/index.js



//import { guardRoute, updatePageTitle } from './middlewares';


vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
    routes: routes,
    linkActiveClass: 'has-current'
});

//router.beforeEach(guardRoute);
router.beforeEach(updatePageTitle);

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/services/base.service.js





var client = axios_default.a.create({
    baseURL: env["a" /* API_URL */],
    withCredentials: true,
    responseType: 'json'
});

/* harmony default export */ var base_service = ({
    execute: function execute(method, resource, data) {
        var _this = this;

        return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', client({
                                method: method,
                                url: resource,
                                data: data
                            }).then(function (response) {
                                console.log("base.service.js GLOBAL LOG ajax query method:" + method + " url:" + resource);
                                console.log('base.service.js GLOBAL response data log', response.data);
                                return response.data;
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    // AUTH methods
    checkLoggin: function checkLoggin(data) {
        return this.execute('post', '/UserSession/login', data);
    },
    checkUser: function checkUser() {
        return this.execute('get', '/UserSession/currentUser');
    },

    // default service methods
    get: function get(resource, option) {
        return this.execute('get', '' + resource, option);
    },
    post: function post(resource, data) {
        return this.execute('post', '' + resource, data);
    },
    create: function create(resource, data) {
        return this.execute('post', '' + resource, data);
    },
    update: function update(resource, id, data) {
        return this.execute('put', resource + '{id}', data);
    },
    delete: function _delete(resource, id) {
        return this.execute('post', resource + '{id}');
    },

    // service orders
    getOrders: function getOrders() {
        return this.execute('get', '/Data/order/');
    },
    getOrder: function getOrder(id) {
        return this.execute('get', '/orders/' + id);
    },
    createOrder: function createOrder(data) {
        return this.execute('post', '/Exec/order/act/new/', data);
    },
    updateOrder: function updateOrder(id, data) {
        return this.execute('put', '/orders/' + id, data);
    },
    deleteOrder: function deleteOrder(id) {
        return this.execute('delete', '/orders/' + id);
    }
});
// CONCATENATED MODULE: ./src/mixins/auth.js
/* harmony default export */ var mixins_auth = ({
    methods: {
        $checkAuth: function $checkAuth() {
            var _this = this;

            console.log("checkAuth");
            if (this.$store.state.isLoggedIn) return;

            this.$AJAX.checkUser().then(function (data) {
                setAuthRoutes(_this, data);
            });
        },
        $logCredentials: function $logCredentials(creds) {
            var _this2 = this;

            console.log("logCredientials");
            if (this.$store.state.isLoggedIn) return;

            this.$AJAX.checkLoggin(creds).then(function (data) {
                //-- 100 is for logging, valid is for currentUser query at each route
                if (data.code === '100' || data.status === 'valid') {
                    setAuthRoutes(_this2, data);

                    _this2.$router.push(_this2.$store.state.appRootPath);
                } else {
                    _this2.$processDataMsg(data);
                }
            });
        }
    }
});

function setAuthRoutes(Vue, data) {
    if (data.code === '100' || data.status === 'valid') {
        Vue.$store.dispatch('login', data);
        //-- Loading dyn-contents for the user
        if (!Vue.$store.state.isDynContentLoaded) Vue.$loadDynContent();
    } else {
        Vue.$processDataMsg(data);
        return Vue.$router.push('/');
    }
}
// CONCATENATED MODULE: ./src/mixins/ui.js

/* harmony default export */ var ui = ({
    methods: {
        $closeDetailBox: function $closeDetailBox() {
            this.showDetail = false;
        }
    }
});
// CONCATENATED MODULE: ./src/mixins/helpers.js
/* harmony default export */ var helpers = ({
    methods: {
        $tomorrowDate: function $tomorrowDate() {
            var today = new Date();
            var tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 1);
            return tomorrow;
        },

        /*
        $validityCheck(context) {
            setInterval(() => {
                if (context.formstate.$invalid) {
                    context.requiredMsg = 'Remplissez les champs requis SVP';
                    context.disabled = true;
                } else {
                    context.requiredMsg = '';
                    context.disabled = false;
                }
            }, 1000)
        },*/
        $checkNull: function $checkNull(value) {
            if (value === '' || value === false || value === null || value === 'undefined' || value === undefined) {
                return false;
            }
            return true;
        },
        $holidays: function $holidays(an) {
            var holidays = [];
            holidays.push(new Date(an, "00", "01"));
            holidays.push(new Date(an, "04", "01"));
            holidays.push(new Date(an, "04", "08"));
            holidays.push(new Date(an, "06", "14"));
            holidays.push(new Date(an, "07", "15"));
            holidays.push(new Date(an, "10", "01"));
            holidays.push(new Date(an, "10", "11"));
            holidays.push(new Date(an, "11", "25"));
            holidays.push(new Date(an, "11", "26"));

            var G = an % 19;
            var C = Math.floor(an / 100);
            var H = (C - Math.floor(C / 4) - Math.floor((8 * C + 13) / 25) + 19 * G + 15) % 30;
            var I = H - Math.floor(H / 28) * (1 - Math.floor(H / 28) * Math.floor(29 / (H + 1)) * Math.floor((21 - G) / 11));
            var J = (an * 1 + Math.floor(an / 4) + I + 2 - C + Math.floor(C / 4)) % 7;
            var L = I - J;
            var MoisPaques = 3 + Math.floor((L + 40) / 44);
            var JourPaques = L + 28 - 31 * Math.floor(MoisPaques / 4);
            holidays.push(new Date(an, MoisPaques - 1, JourPaques));
            holidays.push(new Date(an, MoisPaques - 1, JourPaques - 2));
            holidays.push(new Date(an, MoisPaques - 1, JourPaques + 1));
            holidays.push(new Date(an, MoisPaques - 1, JourPaques + 39));
            holidays.push(new Date(an, MoisPaques - 1, JourPaques + 49));
            holidays.push(new Date(an, MoisPaques - 1, JourPaques + 50));

            return holidays;
        },
        $CompareDateDMY: function $CompareDateDMY(date1, date2) {
            var comp1 = new Date(date1.getFullYear() + "-" + (date1.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + date1.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }));
            var comp2 = new Date(date2.getFullYear() + "-" + (date2.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + date2.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }));
            if (comp1 >= comp2) return true;else return false;
        },
        $formatDateUs: function $formatDateUs(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return startingDate.getFullYear() + "-" + (startingDate.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
        },
        $formatDateTimeFr: function $formatDateTimeFr(date) {
            //-- date must be US YYYY/MM/DD HH:MM
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString('fr-fr', { month: 'short' });
            var day = startingDate.toLocaleString('fr-fr', { weekday: 'short' });
            var dayInt = startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var hours = startingDate.getHours().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var minutes = startingDate.getMinutes().toLocaleString(undefined, { minimumIntegerDigits: 2 });

            return day + ' ' + dayInt + ' ' + month + ' ' + startingDate.getFullYear() + ' ' + hours + ':' + minutes;
        },
        $formatDateFr: function $formatDateFr(date) {
            var noWeekDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString("fr-fr", { month: "short" });
            var day = noWeekDay ? startingDate.toLocaleString("fr-fr", { weekday: "short" }) : '';
            return day + " " + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + " " + month + " " + startingDate.getFullYear();
        },
        $processExecMsg: function $processExecMsg(data) {
            if (!this.$checkNull(data)) this.$Notification.error(data.replace(/<[^>]+>/g, ''));else if (this.$checkNull(data.result)) {
                var code = data.result.code;
                var msg = data.result.msg;

                if (code == '100') {
                    this.$Notification.success('' + msg);
                    return true;
                } else this.$Notification.warn('' + msg);
            } else {
                //-- No return formated, displaying raw result | removing html
                this.$Notification.error(data.replace(/<[^>]+>/g, ''));
            }

            return false;
        },
        $processDataMsg: function $processDataMsg(data) {
            if (this.$checkNull(data.code)) {
                //this.$Notification.warn(`Code: ${data.code} || Msg: ${data.msg}`)
                this.$Notification.warn('' + data.msg);
                return false;
            } else return true;
        },
        $hexToRgb: function $hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        $existValueArrays: function $existValueArrays(tab1, tab2) {
            if (!Array.isArray(tab1)) return false;
            if (!Array.isArray(tab2)) tab2 = [tab2];
            var rs = false;
            if (this.$checkNull(tab1)) {
                for (var i = 0; i < tab1.length; i++) {
                    if (this.$checkNull(tab2)) tab2.forEach(function (item) {
                        if (tab1[i] == item) rs = true;
                    });
                    if (rs) return true;
                }
            }
        }
    }
});
// CONCATENATED MODULE: ./src/mixins/dyn-contents.js
/* harmony default export */ var dyn_contents = ({
    methods: {
        $getContentLabel: function $getContentLabel(contentList, contentId) {
            var content = contentList.find(function (item) {
                return item.id == contentId;
            });
            if (this.$checkNull(content)) {
                return content.label;
            }
            return '';
        },
        $processData: function $processData(data) {
            if (data.code === '501') return;

            var hashTable = new Object();
            data.forEach(function (prestationOption, index) {

                //-- Doesn't like an empty index (creating a one char space one)
                if (prestationOption.text3 == '') prestationOption.text3 = ' ';else prestationOption.text3 = prestationOption.text3.replace(/^[0-9]\-/, '');
                if (prestationOption.text2 == '') prestationOption.text2 = ' ';else prestationOption.text2 = prestationOption.text2.replace(/^[0-9]\-/, '');

                if (!hashTable.hasOwnProperty(prestationOption.text2)) hashTable[prestationOption.text2] = new Object();

                if (hashTable[prestationOption.text2][prestationOption.text3] == undefined) hashTable[prestationOption.text2][prestationOption.text3] = [];

                hashTable[prestationOption.text2][prestationOption.text3].push({ value: prestationOption.id, label: prestationOption.label });
            });
            return hashTable;
        },
        $loadDynContent: function $loadDynContent() {
            var _this = this;

            //-- Loading holidays for this year and the next
            console.log("Loading Dyn Content");
            this.$store.state.contents.holidays = this.$holidays(new Date().getFullYear()).concat(this.$holidays(new Date(new Date().setFullYear(new Date().getFullYear() + 1)).getFullYear()));

            //-- Intializing options
            this.$store.state.contents.prestationOptions = { familyRight: { deed: [], constitution: [] }, commonAct: { deed: [], constitution: [] }, raw: {} };

            this.$AJAX.get('Data/contentByPage/writer/family_right/common_act').then(function (data) {
                if (data.code === '501') return;

                _this.$store.state.contents.prestationOptions.raw = data;

                //-- Getting the writers list 
                //-- Prestation Options
                var tmpWriter = [];
                var tmpFamilyRightDeed = [];
                var tmpFamilyRightCon = [];
                var tmpActDeed = [];
                var tmpActCon = [];
                data.forEach(function (item) {
                    if (item.page.id == 'family_right' && item.fl1 == '0') tmpFamilyRightDeed.push(item);
                    if (item.page.id == 'family_right' && item.fl1 == '1') tmpFamilyRightCon.push(item);
                    if (item.page.id == 'common_act' && item.fl1 == '0') tmpActDeed.push(item);
                    if (item.page.id == 'common_act' && item.fl1 == '1') tmpActCon.push(item);
                    if (item.page.id == 'writer') tmpWriter.push({ label: item.label, id: item.id });
                });
                _this.$store.state.contents.writers = tmpWriter;
                _this.$store.state.contents.prestationOptions.familyRight.deed = _this.$processData(tmpFamilyRightDeed);
                _this.$store.state.contents.prestationOptions.familyRight.constitution = _this.$processData(tmpFamilyRightCon);
                _this.$store.state.contents.prestationOptions.commonAct.deed = _this.$processData(tmpActDeed);
                _this.$store.state.contents.prestationOptions.commonAct.constitution = _this.$processData(tmpActCon);

                _this.$AJAX.get('/Data/configList/page/order_status/order_delay/prestation_type/order_type/format_deed').then(function (data) {
                    if (data.code === '501') return;

                    _this.$store.state.contents.configData = data;
                    _this.$store.state.contents.configFilterData.orderStatus = data.filter(function (item) {
                        return item.type == 'order_status';
                    });

                    //-- Formating for radio button
                    var tmpArray = [];
                    data.filter(function (item) {
                        return item.type == 'order_delay';
                    }).forEach(function (item) {
                        tmpArray.push({ text: item.label, value: item.id });
                    });
                    _this.$store.state.contents.configFilterData.orderDelay = tmpArray;

                    tmpArray = [];
                    data.filter(function (item) {
                        return item.type == 'prestation_type';
                    }).forEach(function (item) {
                        tmpArray.push({ text: item.label, value: item.id });
                    });
                    _this.$store.state.contents.configFilterData.prestationTypes = tmpArray;

                    tmpArray = [];
                    data.filter(function (item) {
                        return item.type == 'order_type';
                    }).forEach(function (item) {
                        tmpArray.push({ text: item.label, value: item.id });
                    });
                    _this.$store.state.contents.configFilterData.orderTypes = tmpArray;

                    var tmpArray = [];
                    data.filter(function (item) {
                        return item.type == 'format_deed';
                    }).forEach(function (item) {
                        tmpArray.push({ text: item.label, value: item.id });
                    });
                    _this.$store.state.contents.configFilterData.formatDeed = tmpArray;
                    _this.$store.dispatch('dynContentLoaded');
                });
            });
        }
    }
});
// CONCATENATED MODULE: ./src/mixins/index.js







vue_esm["default"].mixin(mixins_auth);
vue_esm["default"].mixin(ui);
vue_esm["default"].mixin(helpers);
vue_esm["default"].mixin(dyn_contents);
// CONCATENATED MODULE: ./src/thirdparty/options.js
// v-server-table default options
var serverTableOptions = {
    texts: {
        count: "Affiche {to} des {count} contenus | {count} contenus | un contenu",
        filter: "",
        filterPlaceholder: "Recherchez ici",
        limit: "Fiches:",
        page: "Page:",
        noResults: "Aucune fiche trouvée",
        filterBy: "Filtre par {column}",
        loading: 'Chargement...',
        defaultOption: 'Selectionner {column}'
    }
};

// mini-toastr config
var toastrOptions = {
    timeout: 4000
};
// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 162 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__("T1ft");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// EXTERNAL MODULE: ./node_modules/mini-toastr/mini-toastr.js
var mini_toastr = __webpack_require__("EMpD");

// EXTERNAL MODULE: ./node_modules/vue-tables-2/compiled/index.js
var compiled = __webpack_require__("e9ss");
var compiled_default = /*#__PURE__*/__webpack_require__.n(compiled);

// CONCATENATED MODULE: ./src/thirdparty/index.js







// Notification messages initialization
var notification = {
    install: function install(Vue, options) {
        Vue.prototype.$Notification = mini_toastr["a" /* default */].init(toastrOptions);
    }
};

var mods = [{ modName: es["a" /* default */] }, { modName: compiled["ServerTable"], option: serverTableOptions }, { modName: notification }];

var components = [{ name: vue_select_default.a, id: 'v-select' }];

mods.forEach(function (mod) {
    return vue_esm["default"].use(mod.modName, mod.option ? mod.option : null);
});
components.forEach(function (component) {
    return vue_esm["default"].component(component.id, component.name);
});
// EXTERNAL MODULE: ./src/scss/core.scss
var core = __webpack_require__("8Eth");
var core_default = /*#__PURE__*/__webpack_require__.n(core);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Header = ({
    data: function data() {
        return {
            pageTitle: null
        };
    },

    methods: {
        logout: function logout(e) {
            var _this = this;

            e.preventDefault();
            this.$AJAX.get('/UserSession/logout').then(function () {
                _this.$store.dispatch('logout');
                return _this.$router.push('/Login');
            });
        },
        getPageTitle: function getPageTitle() {
            if (this.$checkNull(this.$route.meta.title)) {
                var _title = this.$route.meta.title.split(' | ');
                this.pageTitle = _title[1];
            }
        }
    },
    watch: {
        '$route': {
            handler: 'getPageTitle',
            immediate: true
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-410acf0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"gHeader"},[_c('div',{staticClass:"gHeader__body"},[_c('div',{staticClass:"gLogo"},[_c('router-link',{attrs:{"to":_vm.$store.state.appRootPath,"aria-label":"PRESTACT"}})],1),_vm._v(" "),_c('nav',{staticClass:"gNav",attrs:{"role":"navigation"}},[(_vm.$store.state.isAdmin)?_c('b-nav',[_c('b-nav-item',{attrs:{"to":{ name: 'calendar' }}},[_c('i',{staticClass:"fas fa-calendar-alt"}),_vm._v(" Calendrier")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'orderListAdmin' }}},[_c('i',{staticClass:"fas fa-file-alt"}),_vm._v(" Commandes")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'users' }}},[_c('i',{staticClass:"fas fa-address-card"}),_vm._v(" Utilisateurs")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'dynContents' }}},[_c('i',{staticClass:"fas fa-database"}),_vm._v(" Données modifiables")]),_vm._v(" "),(_vm.$store.state.userRole == 'admin')?_c('b-nav-item',{attrs:{"to":{ name: 'userHistory' }}},[_c('i',{staticClass:"fas fa-history"}),_vm._v(" Historique utilisateur")]):_vm._e(),_vm._v(" "),(_vm.$store.state.userRole == 'admin')?_c('b-nav-item',{attrs:{"to":{ name: 'statistic' }}},[_c('i',{staticClass:"fas fa-chart-pie"}),_vm._v(" Statistique")]):_vm._e()],1):_c('b-nav',[_c('b-nav-item',{attrs:{"to":{ name: 'newOrder' }}},[_c('i',{staticClass:"fas fa-newspaper"}),_vm._v(" Nouvelle Commande")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'orderList' }}},[_c('i',{staticClass:"fas fa-file-alt"}),_vm._v(" Gestion Commande")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'faq' }}},[_c('i',{staticClass:"fas fa-question-circle"}),_vm._v(" FAQ")])],1)],1),_vm._v(" "),_c('menu',{staticClass:"gToolBox"},[_c('ul',{staticClass:"gToolBox__actions"},[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.pageTitle))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""},on:{"click":_vm.logout}},[_vm._v("Logout")])])]),_vm._v(" "),_c('div',{staticClass:"gToolBox__greeting"},[_c('p',[_vm._v("Bonjour, \n                    "),_c('span',{staticClass:"userName"},[_vm._v(_vm._s(_vm.$store.state.userRole)+" "+_vm._s(_vm.$store.state.UserLogin))])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gToolBox__pic"},[_c('img',{staticClass:"u-responsiveImg",attrs:{"src":__webpack_require__("BQ5I"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_Header = (esExports);
// CONCATENATED MODULE: ./src/layout/Header.vue
function injectStyle (ssrContext) {
  __webpack_require__("q07B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-410acf0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Header,
  layout_Header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_layout_Header = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/Footer.vue
//
//
//
//

/* harmony default export */ var Footer = ({
    data: function data() {
        return {
            currentYear: new Date().getFullYear()
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd9302a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Footer.vue
var Footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"gFooter"},[_vm._v("Copyright © "+_vm._s(_vm.currentYear)+" Prestact")])}
var Footer_staticRenderFns = []
var Footer_esExports = { render: Footer_render, staticRenderFns: Footer_staticRenderFns }
/* harmony default export */ var layout_Footer = (Footer_esExports);
// CONCATENATED MODULE: ./src/layout/Footer.vue
function Footer_injectStyle (ssrContext) {
  __webpack_require__("s5oh")
}
var Footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Footer___vue_template_functional__ = false
/* styles */
var Footer___vue_styles__ = Footer_injectStyle
/* scopeId */
var Footer___vue_scopeId__ = "data-v-4dd9302a"
/* moduleIdentifier (server only) */
var Footer___vue_module_identifier__ = null
var Footer_Component = Footer_normalizeComponent(
  Footer,
  layout_Footer,
  Footer___vue_template_functional__,
  Footer___vue_styles__,
  Footer___vue_scopeId__,
  Footer___vue_module_identifier__
)

/* harmony default export */ var src_layout_Footer = (Footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/Index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Index = ({
    name: 'AppLayout',
    components: {
        AppHeader: src_layout_Header,
        AppFooter: src_layout_Footer
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c65ccbc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Index.vue
var Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[(_vm.$store.state.isLoggedIn)?[_c('AppHeader'),_vm._v(" "),_c('main',{staticClass:"contents"},[_c('transition',{attrs:{"name":"pageTransit","mode":"out-in","appear":""}},[(_vm.$store.state.isLoggedIn)?_c('router-view',{staticClass:"contentBox"}):_vm._e()],1)],1),_vm._v(" "),_c('AppFooter')]:(_vm.$route.path == '/login')?[_c('main',{staticClass:"contents"},[_c('router-view')],1),_vm._v(" "),_c('AppFooter')]:[_c('router-view')]],2)])}
var Index_staticRenderFns = []
var Index_esExports = { render: Index_render, staticRenderFns: Index_staticRenderFns }
/* harmony default export */ var layout_Index = (Index_esExports);
// CONCATENATED MODULE: ./src/layout/Index.vue
var Index_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Index___vue_template_functional__ = false
/* styles */
var Index___vue_styles__ = null
/* scopeId */
var Index___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Index___vue_module_identifier__ = null
var Index_Component = Index_normalizeComponent(
  Index,
  layout_Index,
  Index___vue_template_functional__,
  Index___vue_styles__,
  Index___vue_scopeId__,
  Index___vue_module_identifier__
)

/* harmony default export */ var src_layout_Index = (Index_Component.exports);

// CONCATENATED MODULE: ./src/app.init.js











vue_esm["default"].config.productionTip = false;

var API = {
    install: function install(Vue, options) {
        Vue.prototype.$AJAX = base_service;
    }
};
vue_esm["default"].use(API);

(function () {
    return new vue_esm["default"]({
        name: 'Root',
        template: '<AppLayout />',
        components: { AppLayout: src_layout_Index },
        el: '#app',
        router: src_router,
        store: store,
        mounted: function mounted() {
            var _this = this;

            //-- Check at each routes that the user is still connected
            src_router.afterEach(function (to, from) {
                //console.log(from);
                //console.log("=>");
                //console.log(to.meta.auth);

                if (to.meta.auth) _this.$checkAuth();
            });

            //-- Clearing array izi
            Array.prototype.clear = function () {
                while (this.length > 0) {
                    this.pop();
                } // Fastest
            };

            //-- Used to compare date in an array (find doesn't work)
            Array.prototype.indexOfDate = function (date) {
                for (var i = 0; i < this.length; i++) {
                    if (+this[i] === +date) return i;
                };
                return -1;
            };
        }
    });
})();

/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.78296b1.png";

/***/ }),

/***/ "8Eth":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BQ5I":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "GfHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q07B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s5oh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uaSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DOMAIN_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
var DOMAIN_TITLE = 'PRESTACT';
var DOMAIN = 'https://prestact.wearenotalone.fr/index.php';
var API_URL = '' + DOMAIN;
// export const API_PORT = `5000`;
// export const API_URL = `${DOMAIN}:${API_PORT}`;

/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["0Flw"]);


// WEBPACK FOOTER //
// static/js/app.c6fb4090c5f9834beb8e.js